import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DealerCorrectionReviewService } from '../dealer-correction-review/dealer-correction-review.service';
import { Filter } from '../models/warranties/filter.model';
import { DealerCorrectionReviewModel } from '../models/warranties/dealer-coorection-review.model';
import { SweetUtil } from '../components/commons/sweet/sweet-util-service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-dealer-correction-review',
  templateUrl: './dealer-correction-review.component.html',
  styleUrls: ['./dealer-correction-review.component.css']
})
export class DealerCorrectionReviewComponent implements OnInit {

  filter: Filter = new Filter();
  newMessage: DealerCorrectionReviewModel;
  newChat: boolean = false;
  @Input() messages: DealerCorrectionReviewModel[];
  @Input() warrantyId: number;
  @Input() specialRequestId: number;
  @Input() warrantyStatus: string;

  supportingDocument: File;
  savedFileAbsolutePath: string;


  constructor(public dealerCorrectionReviewService: DealerCorrectionReviewService,
    private sweetUtil: SweetUtil,private sanitizer: DomSanitizer ) {}

  ngOnInit(): void {
    this.fetchWarrantyChats();
  }

  fetchWarrantyChats(){
    this.dealerCorrectionReviewService.getDealerCorrectionReviews(this.specialRequestId).subscribe((dealerCorrectionReviewService) => {
      this.dealerCorrectionReviewService.dealerCorrectionReviews = dealerCorrectionReviewService;
      this.messages = dealerCorrectionReviewService;
      this.messages?.sort((a, b) => a?.id - b?.id);
    });
  }
  postMessage(){
    const inputTextArea = document.getElementById('messageInput') as HTMLInputElement | null;
    const message = inputTextArea?.value;
    let messageReview: DealerCorrectionReviewModel = {
        "specialRequestId": this.specialRequestId,
        "message": message,
        "admin": this.dealerCorrectionReviewService.isAdmin(),
        "receivedTime": new Date(),
        "warrantyId": this.warrantyId,
        "supportingMaterialFilePath": "",
        "supportingMaterialFileName": ""
    }

    this.dealerCorrectionReviewService.saveDealerCorrectionReview(messageReview).subscribe((dealerCorrectionReviewModel) => {
      this.messages.push(dealerCorrectionReviewModel);
      this.ngOnInit();
      inputTextArea.value = "";
      this.newChat = true;
      this.scrollBottom();
    });
  }

  formatDate(date: Date) {
    let passedDate = new Date(date);
    let timeZone = new Date().toString();
    if(passedDate != null){
      return (
        [
          passedDate.getFullYear(),
          this.padTo2Digits(passedDate.getMonth() + 1),
          this.padTo2Digits(passedDate.getDate()),
        ].join('-') +
        ' ' +
        [
          this.padTo2Digits(passedDate.getHours()),
          this.padTo2Digits(passedDate.getMinutes()),
          this.padTo2Digits(passedDate.getSeconds()),
        ].join(':') +
          ' ' +
          [
            timeZone.substr(25, 6)
          ]
      );
    }
  }

  padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  scrollBottom(){
    const el = document.getElementById('message-body');
    if (el) {
      el.scroll(0,1200);
    }
  }

  selectSupportingDocument(supportingDocuments) {
    if (supportingDocuments) {
      this.supportingDocument = supportingDocuments.item(0);
      this.saveSupportingDocument();
    }
  }

  saveSupportingDocument(): void {
    this.dealerCorrectionReviewService.saveSupportingDocument(this.supportingDocument, this.warrantyId, this.specialRequestId).subscribe((savedFilePath) => {
      this.savedFileAbsolutePath = savedFilePath;
      SweetUtil.showSuccess('Upload Successful');
      this.ngOnInit();
    }, (error) => {
      if (error?.status === 200 && error?.error?.text) {
        this.savedFileAbsolutePath = error.error.text;
        SweetUtil.showSuccess('Upload Successful');
        this.ngOnInit();
      } else {
        this.sweetUtil.showError(`Upload Failed`);
      }
    });
  }

  getSupportingDocument(message: DealerCorrectionReviewModel){
    this.dealerCorrectionReviewService.getSupportingDocument(message.supportingMaterialFileName);
  }

  showDealerCorrectionText(): boolean{
    return this.warrantyStatus != "Active" && this.warrantyStatus != "Accepted";
  }
}
